// extracted by mini-css-extract-plugin
module.exports = {"signup_c":"Signup_signup_c__2305w","power_tag":"Signup_power_tag__23oIa"};